import { Component, Input } from '@angular/core';
import { StatePublicHelper } from '@app/core/helpers/state-public.helper';
import { TransactionPrivate } from '@app/core/resources/transaction-private';

@Component({
    selector: 'app-states-separator',
    templateUrl: './states-separator.component.html',
    styleUrls: ['./states-separator.component.scss']
})
export class StatesSeparatorComponent {
    @Input() public isCreateTransaction: boolean = false;
    @Input() public showDivider: boolean = true;
    @Input() public disabledTooltip: boolean = false;
    @Input() public state: string = '';
    public statePublicHelper: StatePublicHelper = new StatePublicHelper();
    public transactionPrivate: TransactionPrivate = new TransactionPrivate();

    // Variable para el estado temporal
    public temporaryState: string | null = null;

    // Función para determinar el estado temporal
    public determineTemporaryState(): void {
        if (this.state === '11' && this.transactionPrivate.attributes.mark_as_send) {
            this.temporaryState = 'Verificando tu pago';
        } else {
            this.temporaryState = null; // Si no se cumple la condición, no se muestra el estado temporal
        }
    }
}
